import {
    SHOW_APP_LOADER, HIDE_APP_LOADER,
} from "../constants/actionTypes";

export const showAppLoader = payload => {
    return {
        type: SHOW_APP_LOADER,
        payload
    }
};

export const hideAppLoader = () => ({
    type: HIDE_APP_LOADER
});